import { useCallback } from 'react';

import { getClassroomInfo } from 'Util/Analytics/getEventLabel';
import { useClassroomContext } from 'Context/ClassroomContext';
import { useMyCourseData } from 'Domain/MyCourseData';
import useMyExternalProfile from 'Routes/Classroom/Domain/useMyExternalProfile';

import useTracking from './useTracking';

const CATEGORY = 'NPS Course';

const CLASSROOM_ACTIONS = {
  SUBMIT: 'Submit',
  CANCEL: 'Cancel',
  SHOW: 'Show',
};

function getFeedbackSubmitEvent(label) {
  return { category: CATEGORY, action: CLASSROOM_ACTIONS.SUBMIT, label };
}

function getFeedbackCancelEvent(label) {
  return { category: CATEGORY, action: CLASSROOM_ACTIONS.CANCEL, label };
}

function getFeedbackShowEvent(label) {
  return { category: CATEGORY, action: CLASSROOM_ACTIONS.SHOW, label };
}

function getEventLabel({ course, subsectionId, subject, userProvider, progress }) {
  const { courseTitle, sectionNumber, subSectionNumber } = getClassroomInfo(course, subsectionId);
  return `User:${userProvider}|Subject:${subject}|Course:${courseTitle}|Section:${sectionNumber}|Subsection:${subSectionNumber}|Progress:${progress}`;
}

function useNPSContentTracking() {
  const { logAction } = useTracking();
  const { courseData, currentSubsectionId } = useClassroomContext();
  const { data: myCourseData } = useMyCourseData();
  const { data: userData } = useMyExternalProfile({ fetchPolicy: 'cache-only' });

  const logFeedbackSubmit = useCallback((progress) => {
    logAction(
      getFeedbackSubmitEvent(
        getEventLabel({
          course: courseData,
          subsectionId: currentSubsectionId,
          subject: myCourseData?.courseInfo?.courseLevel,
          userProvider: userData?.myExternalProfile?.providerName,
          progress,
        })
      )
    );
  }, []);

  const logFeedbackCancel = useCallback((progress) => {
    logAction(
      getFeedbackCancelEvent(
        getEventLabel({
          course: courseData,
          subsectionId: currentSubsectionId,
          subject: myCourseData?.courseInfo?.courseLevel,
          userProvider: userData?.myExternalProfile?.providerName,
          progress,
        })
      )
    );
  }, []);

  const logFeedbackShow = useCallback((progress) => {
    logAction(
      getFeedbackShowEvent(
        getEventLabel({
          course: courseData,
          subsectionId: currentSubsectionId,
          subject: myCourseData?.courseInfo?.courseLevel,
          userProvider: userData?.myExternalProfile?.providerName,
          progress,
        })
      )
    );
  }, []);

  return {
    logFeedbackCancel,
    logFeedbackSubmit,
    logFeedbackShow,
  };
}

export { useNPSContentTracking };
